// extracted by mini-css-extract-plugin
export default {"notificationIcon":"S6hm1kicTUeMlEzU4wNK"};